import styled, { css } from 'styled-components'
import { colors } from '@chegg-ui/theme'
import { fanta } from '@chegg/fanta'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'

export const TourDashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 337px;

  background-color: ${colors.royalXlight};
  padding: ${fanta.spacing.md};
`
export const TourPaperImg = styled.div`
  background-image: ${`url('${publicAssetUrl('tour-grammar-paper.svg')}');`};
  width: 176px;
  height: 118px;
`

export const TourCitationImg = styled.div`
  background-image: ${`url('${publicAssetUrl('tour-citation.svg')}');`};
  width: 149px;
  height: 133px;
`

export const TourExpertCheckImg = styled.div`
  background-image: ${`url('${publicAssetUrl('tour-expert-check.svg')}');`};
  width: 197px;
  height: 125px;
`

export const TourDashboardText = styled.span<{ forceTextWrap?: boolean }>`
  font-size: ${fanta.font.size.lg};
  font-weight: ${fanta.font.weight.heavy};
  text-align: center;
  margin-top: ${fanta.spacing.lg};
  ${({ forceTextWrap }) =>
    forceTextWrap &&
    css`
      padding: 0 ${fanta.spacing.sm};
    `}
`

export const TourHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.royal};
  padding: ${fanta.spacing.xs};
  margin-bottom: ${fanta.spacing.lg};
  width: 100%;
`

export const TourHeaderText = styled.span`
  font-size: ${fanta.font.size.md};
  font-weight: ${fanta.font.weight.heavy};
  color: ${colors.white};
  margin-left: ${fanta.spacing.sm};
`

export const TourCelebrationImg = styled.div`
  background-image: ${`url('${publicAssetUrl('tour-ecelebration.svg')}');`};
  width: 38px;
  height: 36px;
`
